import { createLogger } from '@updater-core/lib/logger';
import { ENVIRONMENT } from '@updater-core/lib/environment';

const logger = createLogger(
  ENVIRONMENT.debug?.routerPersistance,
  '[DEBUG][ROUTER-PERSISTANCE]',
  'color: #69c6af'
);
export default function createRouterPersistanceInteractor({ router }) {
  const persisted = {};

  return {
    selectors: {
      get: (key) => persisted[key]?.object,
      keys: () => Object.keys(persisted),
    },
    actions: {
      add: (key, pathRegex, object, destroy) => {
        const unsubscribe = router.subscribe(() => {
          const newPath = router.currentPath();
          const isNewPath = !new RegExp(pathRegex).test(newPath);

          logger.log('Route change detected', {
            key,
            newPath,
            isNewPath,
          });

          if (!new RegExp(pathRegex).test(newPath)) {
            logger.log('New base path detected, destroying ', key);
            destroy?.();
            unsubscribe?.();
            delete persisted[key];
          }
        });

        persisted[key] = {
          object,
          unsubscribe,
        };
      },
      remove: (key) => {
        const unsubscribe = persisted[key]?.unsubscribe;
        unsubscribe?.();
        delete persisted[key];
      },
    },
  };
}
